import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getUserFromCookie } from "../helpers/api/apiCore";
import { trackPageView, setUser } from "./index";

// Mount once inside the Router. Its only job is one page_view per client-side
// navigation, plus re-attaching the GA identity after a full page load (F5 while
// logged in) so the first hit of a session carries the user dimensions.
//
// Login and logout *events* are deliberately not emitted here. This effect used to
// infer them by diffing the session id between renders, which could not work: both
// logout paths end in a full document load (`Logout.tsx` → window.location.replace,
// and apiCore's 401 handler → window.location.href), so the component that would
// have noticed the id disappearing is destroyed before the effect runs, and the one
// that mounts afterwards suppresses the event as a first run. They are emitted from
// the auth flow itself instead — see ANALYTICS.md B3.
export const RouteAnalytics = () => {
  const { pathname, search } = useLocation();
  const identified = useRef(false);

  useEffect(() => {
    if (identified.current) return;
    identified.current = true;
    const session = getUserFromCookie();
    if (session) setUser(session);
  }, []);

  useEffect(() => {
    // Raw path in — scrubbing happens inside trackPageView so no route can skip it.
    trackPageView(pathname + search);
  }, [pathname, search]);

  return null;
};

export default RouteAnalytics;
